import React, { useState } from 'react';

const ImpactSection = () => {
  const [expandedImage, setExpandedImage] = useState(null);

  const bulletPoints = [
    'Strategy aligned with business goals',
    'Technology designed for long-term growth',
    'Security & performance at the core',
    'Scalable systems that evolve with you',
    'Partnerships focused on outcomes'
  ];

  return (
    <section className="relative bg-gray-50 text-gray-900 py-20 lg:py-28 overflow-hidden border-b border-gray-200">
      {/* Elegant Image Background with Light Overlay */}
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1550684848-fac1c5b4e853?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80')] bg-cover bg-center opacity-30 mix-blend-multiply z-0 pointer-events-none animate-slow-zoom"></div>
      <div className="absolute inset-0 bg-gradient-to-br from-white/95 via-gray-50/90 to-white/95 backdrop-blur-[2px] z-0 pointer-events-none"></div>

      {/* Animated Glowing Orbs */}
      <div className="absolute top-0 right-10 w-[400px] h-[400px] bg-amber-500/20 rounded-full blur-[100px] pointer-events-none animate-pulse z-0"></div>
      <div className="absolute bottom-0 left-10 w-[400px] h-[400px] bg-blue-600/15 rounded-full blur-[100px] pointer-events-none animate-pulse z-0" style={{animationDelay: '1s'}}></div>

      <div className="max-w-7xl mx-auto px-6 md:px-8 relative z-10 grid lg:grid-cols-2 gap-16 items-center">
        
        {/* Left Content: Points & Strategy */}
        <div>
          {/* Badge */}
          <div className="inline-flex items-center border border-gray-200 px-4 py-2 bg-white/60 text-xs font-bold uppercase tracking-widest text-amber-600 mb-6 rounded-md backdrop-blur-sm shadow-sm">
            <span className="w-2 h-2 bg-amber-500 rounded-full mr-2 animate-pulse shadow-[0_0_8px_rgba(245,158,11,0.8)]"></span>
            Innovation & Strategy
          </div>
          
          {/* Heading */}
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold leading-tight uppercase mb-6">
            From Ideas to <span className="text-amber-600">Impact</span>
          </h2>
          
          {/* Description */}
          <p className="text-gray-600 text-base sm:text-lg mb-10 leading-relaxed max-w-xl">
            Garud Stacks empowers businesses by transforming complex ideas into scalable, secure, and future-ready digital solutions that deliver measurable real-world impact.
          </p>
          
          {/* Custom Bullet Points */}
          <ul className="space-y-5">
            {bulletPoints.map((point, index) => (
              <li key={index} className="flex items-start group hover:-translate-y-1 transition-transform duration-300 cursor-default">
                <div className="flex-shrink-0 w-6 h-6 mt-1 flex items-center justify-center rounded-full bg-amber-100 text-amber-600 group-hover:bg-amber-500 group-hover:text-white transition-colors duration-300">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"></path>
                  </svg>
                </div>
                <span className="ml-4 text-gray-700 font-medium text-lg group-hover:text-black transition-colors duration-300">{point}</span>
              </li>
            ))}
          </ul>
        </div>
        
        {/* Right Content: Interactive Image Container */}
        <div className="relative group mt-8 lg:mt-0 animate-float-y">
          {/* Glowing Backplate */}
          <div className="absolute -inset-1 bg-gradient-to-r from-amber-400 to-amber-200 rounded-2xl blur opacity-30 group-hover:opacity-60 transition duration-1000 group-hover:duration-200"></div>
          
          <div className="relative rounded-2xl overflow-hidden shadow-xl border border-gray-100 bg-white aspect-[16/9]">
            <img 
              src="/img/g.png"
              alt="Tech Solutions Impact" 
              onClick={() => setExpandedImage("/img/g.png")}
              className="w-full h-full object-cover transform transition-transform duration-700 group-hover:scale-105 opacity-90 group-hover:opacity-100 cursor-pointer"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-gray-900/40 via-transparent to-transparent pointer-events-none"></div>
          </div>
        </div>
        
      </div>

      {/* Expanded Image Modal */}
      {expandedImage && (
        <div 
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4"
          onClick={() => setExpandedImage(null)}
        >
          <div 
            className="relative w-full max-w-4xl max-h-[90vh] rounded-2xl overflow-hidden shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={expandedImage}
              alt="Expanded view"
              className="w-full h-full object-contain"
            />
            <button
              onClick={() => setExpandedImage(null)}
              className="absolute top-4 right-4 w-10 h-10 bg-white/20 hover:bg-white/40 rounded-full flex items-center justify-center transition-colors duration-300 backdrop-blur-sm"
            >
              <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
              </svg>
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

export default ImpactSection;
